/* eslint-disable no-unused-vars */
import { useNavigate } from 'react-router-dom';
import LayoutProvider from '../../../Contexts/LayoutProvider';
import { useTemplate } from '../../../features/template/TemplateProvider';
import PageTitle from '../../../utils/PageTitle';
import { handleLogoutOpe } from './AuthManageOperation';
import AuthManageProvider, { useAuthManage } from './AuthManageProvider';
import PageHeader from './Components/PageHeader';
import PageTable from './Components/PageTable';
import PageTableMobile from './Components/PageTableMobile';

function PageContent() {
    const navigate = useNavigate();
    const { userList, handleReload } = useAuthManage();

    const { setMessage, setConfirm } = useTemplate();

    const handleLogoutClick = (e, id) => {
        e.stopPropagation();
        setConfirm({
            text: 'Are you sure you want to log out this user?',
            textAction: 'Yes',
            clickAction: () => {
                handleLogoutOpe(id)
                    .then(({ title }) => {
                        setConfirm(null);
                        handleReload();
                        setMessage({ type: 'success', text: title });
                    })
                    .catch((err) => {
                        setMessage({ type: 'error', text: err.toString() });
                    });
            }
        });
    };

    return (
        <div className="inner_page_cont">
            <PageHeader />
            <LayoutProvider>
                <PageTable layout="default" data={userList} handleLogoutClick={handleLogoutClick} />
                <PageTableMobile
                    layout={['md', 'sm', 'xs', 'xxs']}
                    data={userList}
                    handleLogoutClick={handleLogoutClick}
                />
            </LayoutProvider>
        </div>
    );
}

function AuthManagePage() {
    // set page title
    PageTitle(`Auth Manage`);

    return (
        <AuthManageProvider>
            <PageContent />
        </AuthManageProvider>
    );
}

export default AuthManagePage;
